module.exports = __webpack_public_path__ + "d7b676ad62c51de9f0d1b278996c4f0f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_23.jpg
 ** module id = 606
 ** module chunks = 0
 **/